module.exports = __webpack_public_path__ + "static/media/3.4f1f3542.jpg";